export default __webpack_public_path__ + "static/media/ticket-example.14a977a8.jpg";